import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { createPayment } from "../../Redux/Customers/Payment/Action";

const OrderSummaryBill = ({
  deliveryAddress,
  cart,
  handlePrevStep,
  generateWaybill,
  order,
  orderId,
  jwt,
  handleCreatePayment,
  loading,
  shippingCharge = 0,
  finalAmount = 0,
}) => {
  const dispatch = useDispatch();
  const [loadingButton, setLoadingButton] = useState(false);

  useEffect(() => {
    if (cart.error) {
      toast.error("Failed to load cart data!");
    }
  }, [cart.error]);

  if (cart.loading) {
    return (
      <div className="flex justify-center items-center h-[60vh]">
        <CircularProgress size={50} />
      </div>
    );
  }

  return (
    <div className="payment-container">
      <h2 className="payment-heading">ORDER SUMMARY</h2>

      <div className="order-details">
        {/* Delivery Address */}
        <div className="order-section">
          <h3>Delivery Address</h3>
          <p>
            {deliveryAddress?.firstName} {deliveryAddress?.lastName}
            <br />
            {deliveryAddress?.streetAddress}
            <br />
            {deliveryAddress?.city}, {deliveryAddress?.state}{" "}
            {deliveryAddress?.zipCode}
            <br />
            Phone: {deliveryAddress?.mobile}
          </p>
        </div>

        {/* Order Items */}
        <div className="order-section">
          <h3>Order Items</h3>
          {Array.isArray(cart.cart?.cartItems) && cart.cart.cartItems.length > 0 ? (
            cart.cart.cartItems.map((item, index) =>
              item?.product ? (
                <div key={index} className="order-item">
                  <span>{item.product?.title}</span>
                  <div className="order-item-price">
                    ₹{item.product?.discountedPrice} × {item.quantity}
                  </div>
                </div>
              ) : (
                <div
                  key={index}
                  className="order-item text-red-500 italic text-sm"
                >
                  Invalid cart item
                </div>
              )
            )
          ) : (
            <p className="text-gray-500">No items in cart.</p>
          )}
        </div>

        {/* Order Totals */}
        <div className="order-total">
          <div className="order-total-row">
            <span>Subtotal:</span>
            <span>₹{cart.cart?.totalPrice || 0}</span>
          </div>
          <div className="order-total-row">
            <span>Discounted Price:</span>
            <span>₹{cart.cart?.totalDiscountedPrice || 0}</span>
          </div>
          <div className="order-total-row">
            <span>Shipping:</span>
            <span>₹{shippingCharge}</span>
          </div>
          {/* <div className="order-total-row">
            <span>Discount:</span>
            <span>-₹{cart.cart?.discountedPrice || 0}</span>
          </div> */}
          <div className="order-total-row grand-total">
            <span>Total:</span>
            <span>₹{finalAmount}</span>
          </div>
        </div>
      </div>

      {/* Buttons */}
      <div className="payment-footer">
        <button
          type="button"
          className="back-to-address-btn"
          onClick={handlePrevStep}
        >
          ← Back to Address
        </button>

        <button
          type="button"
          className="place-order-btn flex items-center justify-center"
          onClick={async () => {
            setLoadingButton(true);
            try {
              await handleCreatePayment();
              // await generateWaybill();
            } catch (error) {
              console.error("Order processing error:", error);
              toast.error("Something went wrong while placing the order.");
            } finally {
              setLoadingButton(false);
            }
          }}
          disabled={loadingButton || !orderId}
        >
          {loadingButton ? (
            <>
              <CircularProgress size={20} color="inherit" className="mr-2" />
              Processing...
            </>
          ) : (
            "Place Order"
          )}
        </button>
      </div>
    </div>
  );
};

export default OrderSummaryBill;
